import { Arg, Ctx, Mutation, Resolver, Directive } from 'type-graphql'

import { Board } from '../board/board.js'
import { Group } from './group.js'
import { GroupPatch, NewGroup } from './group-type.js'

@Resolver(Group)
export class GroupMutation {
  @Directive('@transaction')
  @Mutation(returns => Group, { nullable: true, description: 'Creates a new board group.' })
  async createGroup(@Arg('group') group: NewGroup, @Ctx() context: ResolverContext): Promise<Group> {
    const { domain, user, tx } = context.state

    return await tx.getRepository(Group).save({
      domain,
      ...group,
      creator: user,
      updater: user
    })
  }

  @Directive('@transaction')
  @Mutation(returns => Group, { description: 'Updates an existing board group.' })
  async updateGroup(
    @Arg('id') id: string,
    @Arg('patch') patch: GroupPatch,
    @Ctx() context: ResolverContext
  ): Promise<Group> {
    const { domain, user, tx } = context.state
    const repository = tx.getRepository(Group)

    const group = await repository.findOneBy({ domain: { id: domain.id }, id })

    return await repository.save({
      ...group,
      ...patch,
      updater: user
    })
  }

  @Directive('@transaction')
  @Mutation(returns => Group, { description: 'Assigns one or more boards to a group.' })
  async joinGroup(
    @Arg('id') id: string,
    @Arg('boardIds', type => [String]) boardIds: string[],
    @Ctx() context: ResolverContext
  ) {
    const { domain, tx } = context.state
    const repository = tx.getRepository(Group)
    const group = await repository.findOneBy({ domain: { id: domain.id }, id })

    const boardRepository = tx.getRepository(Board)

    await Promise.all(
      boardIds.map(async boardId => {
        let board = await boardRepository.findOneBy({ domain: { id: domain.id }, id: boardId })
        board.group = group
        await boardRepository.save(board)
      })
    )

    return await repository.findOne({
      where: { domain: { id: domain.id }, id },
      relations: ['boards']
    })
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, { description: 'Deletes a board group.' })
  async deleteGroup(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<boolean> {
    const { domain, tx } = context.state

    const repository = tx.getRepository(Group)

    /* TODO - 그룹에 소속된 보드가 있는 경우에는 그룹을 지워서는 안된다. */
    const group = await repository.findOneBy({
      domain: { id: domain.id },
      id
    })

    await repository.delete(id)
    return true
  }
}
